import { Button, Stack, VStack } from 'native-base'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CompHeader from '../../commons/CompHeader/CompHeader'
import DataTable from '../../commons/DataTable/DataTable'
import useFetch from '../../hook/useFetch'
import StoreTabs from './StoreTabs'
import { columns } from './static'
import { getStoresWithNoAuth } from '../../apis/store'
import { storeRoles } from '../../components/PreRegister/static/register'

const NoAuthStores = () => {
    const navigate = useNavigate()
    const [role, setRole] = useState('')

    const { data, isLoading } = useFetch({
        name: 'getStoresWithNoAuth',
        service: getStoresWithNoAuth,
        pagination: true,
        params: { role },
        conditionalRefetch: [role]
    })

    return (
        <VStack>
            <CompHeader title='Stores' buttonTitle='New Store' onPress={() => navigate('/admin/pre-register')} />
            <StoreTabs as='noAuthStores' />
            <Stack mb="2.5" mt="1.5" space={2}
                direction={{ base: "column", md: "row" }}
                mx={{ base: "auto", md: "0" }} >
                {storeRoles.map(([id, name]) =>
                    <Button size="sm" key={id}
                        display='inline-flex'
                        variant={role === id ? 'solid' : 'outline'}
                        onPress={() => setRole(id)} >
                        {`Only ${name}`}
                    </Button>
                )}
            </Stack>
            <DataTable tableData={{
                columns: columns(navigate), data,
                isLoading, pagination: true
            }} />
        </VStack>
    )
}

export default NoAuthStores 